/**
 * Created by mac on 12/22/20
 */

const InfoView = cc.Node.extend({
    ctor: function (info) {
        const styles = cleverapps.styles.InfoView;
        this.debugId = "InfoView";

        let children = [];
        children.push(info.rarity && this.createRarity(info.rarity));
        children.push(info.title && this.createWrappedTitle(info.title, info));
        children.push(info.progress && this.createProgressBar(info.progress));
        children.push(info.description && this.createDescription(info.description));
        children.push(info.generator && this.createGenerator(info.generator));
        children.push(info.duration && this.createDuration(info.duration));
        children.push(info.countdown && this.createCountDown(info.countdown));
        children.push(info.remains && this.createRemainsBar(info.remains));

        children = children.concat(info.buttons && this.createButtons(info.buttons));
        const content = new cleverapps.Layout(children.filter(Boolean), {
            direction: cleverapps.UI.VERTICAL,
            padding: styles.padding
        });

        this._super();

        if (cleverapps.gameModes.silentInfoView) {
            this.setVisible(false);
        }

        const withDecorators = styles.decorators;
        const backgroundSize = {
            width: Math.max(content.width, withDecorators ? styles.minWidthWithDecorators : styles.minWidth),
            height: Math.max(content.height, styles.minHeight)
        };

        this.setContentSize2(backgroundSize);

        const background = InfoView.CreateInfoBackground(backgroundSize);
        this.addChild(background);

        content.setAlignment(this.width / 2, this.height / 2);
        this.addChild(content);

        if (withDecorators) {
            styles.decorators.forEach(function (style) {
                const decorator = new cc.Sprite(style.image);
                decorator.setAnchorPoint(0.5, 0.5);
                decorator.setAlignment(style);
                this.addChild(decorator);
            }, this);
        }

        if (info.windowParameters) {
            this.addChild(this.createWindow(info.windowParameters));
        }

        if (info.upgradableLevel) {
            const upgradableLevel = this.createUpgradableLevel(info.upgradableLevel);
            if (upgradableLevel) {
                this.addChild(upgradableLevel);
            }
        }

        this.baseScale = 1;

        if (info.onClicked) {
            cleverapps.UI.onClick(this, info.onClicked);
        } else {
            cleverapps.UI.onClick(this, this.onClicked.bind(this, undefined), {
                interactiveScale: false
            });
        }
    },

    createRarity: function (rarity) {
        const styles = cleverapps.styles.InfoView.rarity;

        const icon = new cc.Sprite(bundles.merge.frames[`icon_${rarity}`]);
        icon.setScale(0.7);

        return cleverapps.UI.wrapWithPadding(icon, styles.padding);
    },

    createTitle: function (unit) {
        const styles = cleverapps.styles.InfoView.title;

        let text = unit;
        if (typeof unit !== "string") {
            text = unit.title ? unit.title : cleverapps.unitsLibrary.getUnitName(unit);
        }
        let textWidth = styles.width;

        let icon;
        if (unit.image) {
            icon = new cc.Sprite(unit.image);
        } else if (unit.icon) {
            icon = UnitView.getUnitImage(unit);
        }

        let title;
        if (TextWithIcon.IsApplicable(text)) {
            title = new TextWithIcon(text, {
                font: cleverapps.styles.FONTS.INFO_BIG_TEXT
            });
        } else {
            title = cleverapps.UI.generateOnlyText(text, cleverapps.styles.FONTS.INFO_TEXT);
            title.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        }

        if (icon) {
            cleverapps.UI.fitToBox(icon, {
                width: styles.width * 0.4,
                height: title.height * 1.8
            });
            textWidth -= icon.width * icon.scaleX;
        }

        if (title instanceof cleverapps.UI.LabelTTF) {
            title.splitInHalf(textWidth);
        }
        title.fitTo(textWidth);

        return new cleverapps.Layout([icon, title].filter(Boolean), {
            direction: cleverapps.UI.HORIZONTAL,
            padding: icon ? styles.iconPadding : styles.padding
        });
    },

    createWrappedTitle: function (unit, info) {
        const isTitleOnlyElement = !(info.progress || info.description || info.generator || info.duration || info.countdown || info.duration);
        if (info.rarity || isTitleOnlyElement) {
            return this.createTitle(unit);
        }

        const bgFrame = bundles.merge.frames.infoview_title_bg_png;
        if (!bgFrame) {
            return this.createTitle(unit);
        }

        const styles = cleverapps.styles.InfoView.title;
        const bg = new cc.Scale9Sprite(bgFrame);
        const capInsets = bg.getCapInsets();
        bg.setCapInsets({ ...capInsets, y: bg.height * 0.66, height: bg.height * 0.15 });
        const title = this.createTitle(unit);
        bg.setContentSize2(styles.width + styles.padding.x * 2, title.height);
        bg.addChild(title);
        title.setAlignment(bg.width / 2, bg.height / 2);
        return bg;
    },

    createGenerator: function (generator) {
        const styles = cleverapps.styles.InfoView.generator;

        const text = cleverapps.UI.generateOnlyText(Messages.get("InfoView.generator", generator), cleverapps.styles.FONTS.INFO_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.fitTo(styles.width);
        return cleverapps.UI.wrapWithPadding(text, styles.padding);
    },

    createDescription: function (description) {
        const styles = cleverapps.styles.InfoView.description;

        const text = cleverapps.UI.generateOnlyText(description, cleverapps.styles.FONTS.INFO_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.width, styles.height);
        return cleverapps.UI.wrapWithPadding(text, styles.padding);
    },

    createProgressBar: function (progress) {
        const abTestStyles = cleverapps.styles.InfoViewAbTest;
        const styles = abTestStyles ? cleverapps.styles.InfoViewAbTest.bar : cleverapps.styles.InfoView.bar;

        if (styles.noText && progress.total === 1) {
            return;
        }

        const val = progress.total - progress.value;

        const bar = new ScaledProgressBar({
            type: styles.mainType || ScaledProgressBar.Types.blue_with_frames,
            showAllDelimiters: progress.increasing
        });
        bar.setAnchorPoint(0.5, 0.5);
        bar.setLength(styles.width);
        bar.setGoal(progress.total);
        bar.setPercentage(val);

        if (cleverapps.config.ui === "heroes") {
            for (let i = 1; i <= Math.min(val, progress.total - 1); i++) {
                const delimiter = bar.getDelimiter();
                delimiter.setAnchorPoint(0, 0);
                delimiter.setAlignment(i * bar.width / progress.total - delimiter.width, 0);
                bar.addChild(delimiter);
            }
        } else if (!styles.noText) {
            const amount = cleverapps.UI.generateImageText(`${val}/${progress.total}`, cleverapps.styles.FONTS.INFO_BAR_TEXT);
            amount.setAlignment(styles.amount);
            bar.addChild(amount);
        }

        return cleverapps.UI.wrapWithPadding(bar, styles.padding);
    },

    createRemainsBar: function (remains) {
        const styles = cleverapps.styles.InfoView.bar;

        const progress = new ScaledProgressBar({
            type: styles.type
        });
        progress.setGoal(remains.total);
        progress.setPercentage(remains.value);
        progress.setLength(styles.width);
        return cleverapps.UI.wrapWithPadding(progress, styles.padding);
    },

    createDuration: function (duration) {
        const styles = cleverapps.styles.InfoView.timer;

        const timer = new cleverapps.CountDownView(duration, {
            font: cleverapps.styles.FONTS.INFO_TIMER_TEXT,
            icon: {
                frame: bundles.small_timer_merge.frames.timer_png,
                json: bundles.small_timer.jsons.small_timer_json,
                animation: "animation",
                stopped: true
            }
        });
        return cleverapps.UI.wrapWithPadding(timer, styles.padding);
    },

    createCountDown: function (duration) {
        const styles = cleverapps.styles.InfoView.timer;

        const countdown = this.countdown = new cleverapps.CountDown(duration, {
            onFinish: InfoView.CloseInfo
        });

        const timer = new cleverapps.CountDownView(countdown, {
            font: cleverapps.styles.FONTS.INFO_TIMER_TEXT,
            icon: {
                frame: bundles.small_timer_merge.frames.timer_png,
                json: bundles.small_timer.jsons.small_timer_json,
                animation: "animation"
            }
        });
        return cleverapps.UI.wrapWithPadding(timer, styles.padding);
    },

    createButtons: function (actions) {
        const buttons = [];

        buttons.push(actions.build && this.createBuildButton(actions.build));
        buttons.push(actions.instant && this.createInstantButton(actions.instant));
        buttons.push(actions.energy && this.createEnergyButton(actions.energy));
        buttons.push(actions.wands && actions.wands.label && this.createAttackLabel(actions.wands.label));
        buttons.push(actions.wands && this.createAttackButton(actions.wands));
        buttons.push(actions.extraWands && actions.extraWands.label && this.createAttackLabel(actions.extraWands.label));
        buttons.push(actions.extraWands && this.createAttackButton(actions.extraWands));
        buttons.push(actions.speedup && this.createSpeedUpButton(actions.speedup));
        buttons.push(actions.sell && this.createSellButton(actions.sell));
        buttons.push(actions.unlock && this.createUnlockButton(actions.unlock));
        buttons.push(actions.valuable && this.createValuableButton(actions.valuable));
        buttons.push(actions.create && this.createCreateButton(actions.create));
        buttons.push(actions.locate && this.createLocateButton(actions.locate));
        buttons.push(actions.explode && this.createExplodeButton(actions.explode));
        buttons.push(actions.delete && this.createDeleteButton(actions.delete));

        return buttons;
    },

    createLocateButton: function (options) {
        const styles = cleverapps.styles.InfoView.button;
        const button = new cleverapps.UI.Button({
            type: styles.type.default,
            width: styles.width,
            height: styles.height,
            text: Messages.get("Find"),
            onClicked: this.onClicked.bind(this, options.action, true)
        });
        return cleverapps.UI.wrapWithPadding(button, styles.padding);
    },

    createExplodeButton: function (options) {
        const styles = cleverapps.styles.InfoView.button;
        const button = new cleverapps.UI.Button({
            type: styles.type.default,
            width: styles.width,
            height: styles.height,
            text: `<<${Messages.get("Explode")}`,
            icons: {
                "<<": bundles.merge.frames.icon_explode
            },
            onClicked: this.onClicked.bind(this, options.action, true)
        });
        return cleverapps.UI.wrapWithPadding(button, styles.padding);
    },

    createDeleteButton: function (options) {
        const styles = cleverapps.styles.InfoView.thinButton;
        return new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            text: Messages.get("Remove"),
            textVariant: "tiny",
            onClicked: this.onClicked.bind(this, () => {
                cleverapps.focusManager.display({
                    focus: "RemoveUnitWindow",
                    action: function (f) {
                        new SellUnitWindow(options.unit);
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            }, true),
            type: styles.type.secondary
        });
    },

    createValuableButton: function (options) {
        const styles = cleverapps.styles.InfoView.button;

        const button = new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            type: styles.type.secondary,
            text: TextWithIcon.ICONS_BY_NAME[options.unit.code] + options.unit.getData().value,
            onClicked: this.onClicked.bind(this, options.action, true)
        });
        return cleverapps.UI.wrapWithPadding(button, styles.padding);
    },

    createBuildButton: function (options) {
        const styles = cleverapps.styles.InfoView.button;

        options = {
            type: options.type || styles.type.default,
            text: options.text || `${Messages.get("InfoView.button.build")}--`,
            action: options instanceof Function ? options : options.action,
            adviceTarget: options.adviceTarget || "build"
        };

        const button = new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            text: options.text,
            onClicked: this.onClicked.bind(this, options.action, true),
            type: options.type
        });
        button.adviceTarget = options.adviceTarget;
        return cleverapps.UI.wrapWithPadding(button, styles.padding);
    },

    createCreateButton: function (options) {
        const styles = cleverapps.styles.InfoView.button;

        const button = new UseEnergyButton({
            energy: options.energy,
            onClicked: this.onClicked.bind(this, options.action, true),
            width: styles.width,
            height: styles.height,
            type: styles.type.default
        });

        return cleverapps.UI.wrapWithPadding(button, styles.padding);
    },

    createInstantButton: function (options) {
        return this.createBuildButton({
            type: cleverapps.styles.InfoView.button.type.secondary,
            text: `${Messages.get("InfoView.button.instant")}^^`,
            action: options,
            adviceTarget: "instant"
        });
    },

    createSellButton: function (options) {
        const styles = cleverapps.styles.InfoView.button;

        const button = new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            text: Messages.get(Unit.CalcSellPrice(options.unit) > 0 ? "Sell" : "Remove"),
            onClicked: this.onClicked.bind(this, () => {
                cleverapps.focusManager.display({
                    focus: "SellUnitWindow",
                    action: function (f) {
                        new SellUnitWindow(options.unit);
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            }),
            type: styles.type.secondary
        });
        return cleverapps.UI.wrapWithPadding(button, styles.padding);
    },

    createUnlockButton: function (options) {
        const styles = cleverapps.styles.InfoView.button;

        const button = new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            text: Messages.get("Unlock"),
            type: styles.type.default,
            onClicked: this.onClicked.bind(this, options.action, true)
        });
        return cleverapps.UI.wrapWithPadding(button, styles.padding);
    },

    createEnergyButton: function (options) {
        const styles = cleverapps.styles.InfoView.button;

        if (options.energy) {
            const button = new UseEnergyButton({
                energy: options.energy,
                onClicked: this.onClicked.bind(this, options.action, true),
                width: styles.width,
                height: styles.height,
                type: styles.type.default
            });
            button.adviceTarget = "energy";
            return cleverapps.UI.wrapWithPadding(button, styles.padding);
        }

        return this.createBuildButton({
            text: `${Messages.get("InfoView.button.energy")}${options.isQuick ? "" : "--"}`,
            action: options.action,
            adviceTarget: "energy"
        });
    },

    createAttackButton: function (options) {
        const styles = cleverapps.styles.InfoView.button;

        const button = new WandsAttackButton({
            wands: options.wands,
            onClicked: this.onClicked.bind(this, options.action, true),
            width: styles.width,
            height: styles.height,
            type: styles.type.default
        });
        button.adviceTarget = "wandsAttack";
        return cleverapps.UI.wrapWithPadding(button, styles.padding);
    },

    createAttackLabel: function (options) {
        const styles = cleverapps.styles.InfoView.label;

        const label = cleverapps.UI.generateOnlyText(Messages.get(options), cleverapps.styles.FONTS.BUTTON_LABEL);
        label.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        label.setDimensions(styles.width, styles.height);

        return cleverapps.UI.wrapWithPadding(label, styles.padding);
    },

    createSpeedUpButton: function (options) {
        const styles = cleverapps.styles.InfoView.button;

        let eventName = cleverapps.EVENTS.SPENT.RESET;
        if (options.unit && options.unit.getType() === "fruit") {
            eventName = cleverapps.EVENTS.SPENT.FRUIT;
        }
        const buttonOptions = {
            price: options.price || Unit.CalcSpeedUPPrice(options.duration),
            canCoins: options.canCoins !== undefined ? options.canCoins : true,
            onClicked: this.onClicked.bind(this, options.action),
            eventName,
            speedUp: true,
            source: options.unit,
            type: styles.type.secondary,
            width: styles.width,
            height: styles.height
        };

        let component;
        if (options.unit) {
            component = options.unit.findComponent(Fruit) || options.unit.findComponent(MiniGame);
        }

        if (component && ConfirmSpeedUpWindow.isAvailable(buttonOptions.price)) {
            buttonOptions.confirmWindowOptions = {
                price: options.price,
                timeLeft: this.countdown.getTimeLeft(),
                totalDuration: component.harvestDuration
            };
        }

        const button = new UseGoldButton(buttonOptions);
        button.adviceTarget = "speedup";
        return cleverapps.UI.wrapWithPadding(button, styles.padding);
    },

    createWindow: function (options) {
        const styles = cleverapps.styles.InfoView.guide;

        const button = new cleverapps.UI.HelpButton({
            callback: function () {
                cleverapps.focusManager.display({
                    stack: Map2dLocation.currentLocation.tutorial.checkConditions({ unit: options.unit }) || cleverapps.tutorial.checkConditions({ unit: options.unit }),
                    focus: "InfoViewGuide",
                    action: function (f) {
                        if (options.unitsLibrary) {
                            new UnitsLibraryWindow(options.unit);
                        } else if (options.landmark) {
                            new DonorProgressWindow(options.landmark);
                        } else {
                            new GuideWindow(options.guideOptions, options.unit);
                        }

                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
                InfoView.CloseInfo();
            } 
        });
        button.setAnchorPoint(0.5, 0.5);
        button.setAlignment(styles);
        return button;
    },

    createUpgradableLevel: function (level) {
        const styles = cleverapps.styles.InfoView.upgradableLevel;

        if (!styles) {
            return;
        }

        const bg = new cc.Sprite(bundles.merge.frames.upgradable_level_png);
        bg.setAlignment(styles);

        const text = cleverapps.UI.generateImageText(level, cleverapps.styles.FONTS.UPGRADABLE_LEVEL_TEXT);
        text.setAnchorPoint(0.5, 0.5);
        text.setAlignment(styles.text);
        bg.addChild(text);

        return bg;
    },

    onClicked: function (callback, needInterstitial) {
        if (this.clicked) {
            return;
        }
        this.clicked = true;

        if (callback && typeof callback !== "function") {
            callback = undefined;
            cleverapps.throwAsync("callback is not a function");
        }

        if (!needInterstitial
            || cleverapps.adsLimits.state(AdsLimits.TYPES.INTERSTITIAL) !== AdsLimits.STATE_READY
            || Map2dLocation.currentLocation.tutorial.isActive()
            || cleverapps.tutorial.isActive()
            || cleverapps.focusManager.isFocused()) {
            InfoView.CloseInfo(callback);
            return;
        }

        const close = this.createListener(() => {
            InfoView.CloseInfo(callback);
        });
            
        cleverapps.focusManager.display({
            focus: "showInterstitialInfo",
            action: function (f) {
                cleverapps.rewardedAdsManager.showInterstitial({
                    limit: AdsLimits.TYPES.INTERSTITIAL,
                    placement: AdsLimits.TYPES.INTERSTITIAL_INACTIVE
                }, () => {
                    f();
                    close();
                });
            }
        });
    },

    beforeRemove: function () {
        cc.Base.PerformRecursive(this, (node) => {
            if (node instanceof cleverapps.UI.Button) {
                node.disable();
            }
        });
    }
});

InfoView.SqueezeAndDisplay = function (unit) {
    if (InfoView.blocked) {
        return;
    }

    const wasOpened = InfoView.IsDisplayedFor(unit);
    if (!wasOpened) {
        InfoView.CloseInfo();
    }

    InfoView.blocked = unit;
    unit.squeeze(() => {
        InfoView.blocked = false;
        if (wasOpened) {
            InfoView.CloseInfo();
        } else {
            InfoView.DisplayInfo(unit);
        }
    });
};

InfoView.DisplayInfo = function (unit) {
    if (cleverapps.config.demoMode) {
        InfoView.CreateInfo({
            title: cleverapps.unitsLibrary.getUnitName(unit),
            description: `(${unit.code}${unit.stage})`
        }, unit);

        return;
    }

    const info = unit.getActionInfo();

    if (!info) {
        return;
    }

    const cantShowInfo = Map2dLocation.currentLocation.tutorial.isActive() && !Map2dLocation.currentLocation.tutorial.checkConditions({ move: unit })
        || cleverapps.tutorial.isActive() && !cleverapps.tutorial.checkConditions({ move: unit })
        || Map2d.currentMap.pathIndicator && Map2d.currentMap.pathIndicator.isInfoViewShown(unit);

    if (unit.onGetView() && !unit.isBlocked() && !Map2d.currentMap.dragging && !cantShowInfo) {
        if (InfoView.IsOpened()) {
            InfoView.CloseInfo();
        }

        InfoView.CreateInfo(info, unit);

        unit.playClickSound();
        cleverapps.eventBus.trigger("openInfoView");
    }
};

InfoView.IsPreventClicks = function () {
    return InfoView.latestType && InfoView.latestType !== SimpleInfoView;
};

InfoView.IsDisplayedFor = function (unit) {
    return InfoView.latestParent === unit || InfoView.blocked === unit;
};

InfoView.IsOpened = function () {
    return Boolean(InfoView.latestParent) || Boolean(InfoView.blocked);
};

InfoView.Clear = function (unit) {
    if (!unit || InfoView.IsDisplayedFor(unit)) {
        InfoView.latestType = undefined;
        InfoView.latestParent = undefined;
    }
    if (!unit || InfoView.blocked === unit) {
        InfoView.blocked = false;
    }
};

InfoView.CloseInfo = function (action, silent, delay) {
    const latestParent = InfoView.latestParent;
    let duration = delay || 0;

    if (latestParent) {
        InfoView.latestType = undefined;
        InfoView.latestParent = undefined;
        const view = latestParent.onGetView();
        if (!view) {
            return;
        }
        view.outline(true);

        if (!view.getAdditionalView("info")) {
            cleverapps.throwAsync("No additional view of type info!");
        }

        const withAction = Boolean(action);

        if (duration) {
            Map2dLocation.currentLocation.setTimeout(() => {
                view.removeAdditionalView("info", silent);
                latestParent.onInfoClosed(withAction);
            }, duration);
        } else {
            view.removeAdditionalView("info", silent);
            latestParent.onInfoClosed(withAction);
        }

        duration += 100;

        Map2dLocation.currentLocation.setTimeout(() => {
            cleverapps.eventBus.trigger("closeInfoView");
        }, 500);

        cleverapps.userStatus.reportUserAction();
    }

    if (typeof action === "function") {
        Map2dLocation.currentLocation.setTimeout(action, duration);
    }

    if (duration && latestParent) {
        latestParent.setBlock(true);
        Map2dLocation.currentLocation.counter.setTimeout(() => latestParent.setBlock(false), duration);
    }

    return latestParent;
};

InfoView.CreateInfo = function (info, unit) {
    const styles = cleverapps.styles.InfoView;
    let dx = styles.dx;
    let dy = styles.dy;
    let Constructor;

    if (info.actions) {
        Constructor = FieldInfoView;
    } else if (info.simpleInfo) {
        Constructor = SimpleInfoView;
    } else if (info.feedableInfoView) {
        Constructor = FeedableInfoView;
        dx = styles.feedable.dx;
        dy = styles.feedable.dy;
    } else {
        Constructor = InfoView;
    }

    const infoView = new Constructor(info, unit);

    const parent = unit.onGetView();
    infoView.setAlignment(parent.width / 2 + dx, parent.height + dy);
    infoView.setAnchorPoint(0.5, 0);
    infoView.setLocalZOrder(2);

    parent.animateAppearAdditionalView("info", infoView);
    parent.outline();

    cleverapps.Scenes.GetSceneComponent(Map2dLocationSceneComponent).makeNodeVisible(infoView);

    cleverapps.eventBus.on("openWindow", () => {
        InfoView.CloseInfo();
    }, infoView);

    InfoView.latestType = Constructor;
    InfoView.latestParent = unit;

    unit.onInfoOpened();
};

InfoView.CreateInfoBackground = function (size) {
    const styles = cleverapps.styles.InfoView;

    const background = cleverapps.UI.createScale9Sprite(bundles.merge.frames.background, cleverapps.UI.Scale9Rect.TwoPixelXY);
    background.setContentSize2(size.width, size.height);
    background.setAlignment(size.width / 2, size.height / 2);

    const pointer = new cc.Sprite(bundles.merge.frames.pointer);
    pointer.setAlignment(styles.pointer);
    background.addChild(pointer);

    return background;
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    INFO_TEXT: {
        name: "nostroke",
        size: 28,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    INFO_BIG_TEXT: {
        name: "nostroke",
        size: 35,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    BUTTON_LABEL: {
        size: 24,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    INFO_TIMER_TEXT: {
        name: "nostroke",
        size: 24,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    INFO_BAR_TEXT: {
        size: 25,
        color: cleverapps.styles.COLORS.WHITE
    }
});

cleverapps.styles.InfoView = {
    minHeight: 0,
    minWidth: 0,
    minWidthWithDecorators: 0,

    dx: 0,
    dy: 10,
    multipleDy: 10,
    feedable: {
        dx: -130,
        dy: -40
    },

    padding: {
        x: 0,
        top: 0,
        bottom: 16
    },

    pointer: {
        x: { align: "center" },
        y: -5
    },

    rarity: {
        padding: {
            top: 11,
            bottom: 10
        }
    },

    title: {
        width: 185,
        padding: {
            x: 22,
            top: 11,
            bottom: 10
        },
        iconPadding: {
            left: 10,
            right: 20,
            top: 11,
            bottom: 10
        }
    },

    generator: {
        width: 185,
        padding: {
            x: 22,
            y: 5
        }
    },

    description: {
        width: 200,
        height: 80,
        padding: {
            x: 22,
            y: 5
        }
    },

    bar: {
        width: 170,
        padding: {
            x: 22,
            y: 8
        },
        type: ScaledProgressBar.Types.red,

        amount: {
            x: { align: "center" },
            y: { align: "center" }
        }
    },

    timer: {
        padding: {
            x: 22,
            top: 3,
            bottom: 5
        }
    },

    button: {
        width: 170,
        height: 70,
        padding: {
            x: 22,
            y: 6
        },
        type: {
            default: cleverapps.styles.UI.Button.Images.button_green,
            secondary: cleverapps.styles.UI.Button.Images.button_blue
        }
    },

    thinButton: {
        width: 170,
        height: 45,
        type: {
            default: cleverapps.styles.UI.Button.Images.button_green,
            secondary: cleverapps.styles.UI.Button.Images.button_blue
        }
    },

    label: {
        width: 185,
        height: 55,
        padding: {
            x: 22,
            top: 4,
            bottom: -3
        }
    },

    guide: {
        x: { align: "right", dx: 35 },
        y: { align: "top", dy: 35 }
    }
};
